import { useGetAllEligibleVinsQuery } from '~/api/generated-api';
import { useOrgId } from '~/common/hooks/useOrgId';
import type { WizardStepProps } from '~/features/integrations/partners/types';

import VehicleSelectionStep from '../../shared/vehicleSelection/VehicleSelectionStep';
import { PARTNER_IDS } from '../../types';
import {
  CoastSelectVehiclesSubView,
  CoastViewVehiclesSubView,
} from './coastVehicleSelection.config';

/** Coast's second wizard step: enroll all eligible vehicles, or pick them individually. */
const CoastVehicleStep = (props: WizardStepProps) => {
  const organizationId = useOrgId();
  const { currentData: response, isFetching } = useGetAllEligibleVinsQuery(
    { 'cs-organization': organizationId, providerCode: 'COAST' },
    { skip: !organizationId }
  );
  const eligibility = response?.success ? response.result : undefined;
  // A background refetch keeps the current data usable; only a first load blocks the step.
  const isEligibilityLoading = !organizationId || (!response && isFetching);
  const isEligibilityError = !isEligibilityLoading && !eligibility;

  return (
    <VehicleSelectionStep
      {...props}
      eligibleCount={eligibility?.total_items ?? 0}
      selectedVins={eligibility?.vins}
      isEligibilityLoading={isEligibilityLoading}
      isEligibilityError={isEligibilityError}
      partnerId={PARTNER_IDS.COAST}
      testIdPrefix="coast-vehicle-step"
      translationKeys={{
        sectionTitle: 'integrations:coast.vehicleStep.sectionTitle',
        allOption: 'integrations:coast.vehicleStep.allOption',
        individualOption: 'integrations:coast.vehicleStep.individualOption',
      }}
      ViewVehiclesSubView={CoastViewVehiclesSubView}
      SelectVehiclesSubView={CoastSelectVehiclesSubView}
    />
  );
};

export default CoastVehicleStep;
